import React, { FunctionComponent } from 'react';

import { CategoryPreviewResponse } from '@domains/categories';

import { CategoryCard } from '@components/catalog/CategoryCard/CategoryCard';
import { Container } from '@components/common/Container/Container';

import styles from './CategoriesGrid.module.scss';

export type CategoryCardProps = {
    categories: CategoryPreviewResponse[];
    className?: string;
};

export const CategoriesGrid: FunctionComponent<CategoryCardProps> = (props) => {
    const { categories, className } = props;

    return (
        <div className={className}>
            <Container>
                <ul className={styles.grid}>
                    {categories.map(({ id, thumbnail, name, slug }, index) => (
                        <li key={index} className={styles.item}>
                            <CategoryCard id={id} slug={slug} image={thumbnail} title={name} />
                        </li>
                    ))}
                </ul>
            </Container>
        </div>
    );
};
